var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 436,
    height: 436,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ED6A5A",
    transform: "matrix(0.851562 0 0 0.851562 0 3.05176e-05)",
    d: "M258.535 433.754C230.761 434.146 223.187 419.431 209.998 397.779L149.534 298.268L80.3408 183.568C69.9816 164.277 75.2188 139.101 96.0089 129.052C99.1314 127.543 102.434 126.459 105.705 125.324L233.326 80.9677C239.935 78.6293 246.787 76.2193 253.741 75.2007L253.918 75.1827C258.215 74.7925 262.589 75.9531 266.697 77.109L388.102 119.07C396.762 122.051 405.717 124.851 414.142 128.429C433.872 136.808 442.094 161.564 433.003 180.753C430.526 185.981 427.326 190.893 424.379 195.865L346.313 324.553L299.261 402.973C289.356 419.813 280.085 432.119 258.535 433.754ZM278.682 130.855L278.549 313.578L236.364 313.625C235.603 313.63 234.078 313.826 233.434 313.534L233.12 131.448C232.105 132.073 230.3 132.3 229.108 132.734L126.887 168.848C127.294 169.772 127.968 170.633 128.51 171.488L178.929 253.568L256.405 382.555L385.02 169.304L278.682 130.855Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.62064e47674bb865f5244c549a4ee6c3.svg";
export { ForwardRef as ReactComponent };